import React from 'react';
import { Card, Divider } from '@mui/material';
import { connect } from 'react-redux';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

const DashboardCard = ({ title, value, unit, userAdded, id, setDashboardModal, editing }) => {
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });
  const style = { transition, transform: CSS.Transform.toString(transform) };
  return (
    <Card
      className='dashboard-card'
      variant='outlined'
      sx={{
        borderRadius: '20px',
      }}>
      {editing && (
        <div className='chart-move' style={{ style }} ref={setNodeRef} {...attributes} {...listeners}>
          <i className='fas fa-up-down-left-right move-icon' style={{ fontSize: '16px' }} title='Move Chart'></i>
        </div>
      )}
      <div style={{ display: userAdded ? 'flex' : 'none', position: 'absolute', right: 0, top: 0 }}>
        <button
          style={{ border: '0px', background: 'inherit', padding: '8px 15px' }}
          onClick={() => {
            setDashboardModal({ show: true, id: id, action: 'delete' });
          }}>
          <i className='fa-solid fa-xmark x-icon' style={{ fontSize: '15px' }} title='Delete Component'></i>
        </button>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center' }}>
        <h4 className='card-title'>
          <b>{title}</b>
        </h4>
      </div>
      <Divider />
      <div style={{ display: 'flex', justifyContent: 'center', margin: 18, alignItems: 'center', flexDirection: 'column' }}>
        <span
          style={{
            display: 'flex',
            alignItems: 'center',
            alignContent: 'center',
            justifyContent: 'center',
            margin: unit == null ? '12px 5px' : '0px',
          }}
          className='card-value'>
          <b>{value}</b>
        </span>
        <span
          style={{ display: 'flex', alignItems: 'center', alignContent: 'center', justifyContent: 'center' }}
          className='card-unit'>
          <span>{unit}</span>
        </span>
      </div>
      <div
        style={{
          display: userAdded ? 'flex' : 'none',
          position: 'absolute',
          right: 0,
          bottom: 0,
        }}>
        <button
          style={{ border: '0px', background: 'inherit', padding: '8px 15px' }}
          onClick={() => {
            setDashboardModal({ show: true, id: id });
          }}>
          <i className='fa-solid fa-pen' style={{ fontSize: '15px' }} title='Edit Component'></i>
        </button>
      </div>
    </Card>
  );
};

const mapStateToProps = (state) => {};

const mapDispatchToProps = (dispatch) => {};

export default connect()(DashboardCard);
